import axios from 'axios'
import { store } from '@/store/store'
import config from '@/config'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const gptApi = {
  // Conversation
  postUploadDocument: (request) => {
    const { pageId, data } = request
    return instance().post(`api/openai/${pageId}/langchain/ai-search/upload-documents`, data)
  },
  getDocumentList: (request) => {
    const { pageId, params } = request
    return instance().get(`/api/openai/${pageId}/documents/groups`, { params })
  },
  deleteDocumentByGroupId: (request) => {
    const { pageId, data } = request
    return instance().delete(`/api/openai/${pageId}/langchain/ai-search/delete-documents`, { data })
  },
  // Analytics
  getChatGPTConversation: (request) => {
    const { pageId, params } = request
    return instance().get(`/api/openai/${pageId}/cms/answers-result`, { params })
  },
  getChatGPTSummarizeUserQuestion: (request) => {
    const { pageId, params } = request
    return instance().get(`/api/openai/${pageId}/cms/summarize-user-question`, { params })
  },
  getChatGPTSummarizeUserQuestionDetail: (request) => {
    const { pageId, params } = request
    return instance().get(`/api/openai/${pageId}/cms/summarize-user-question/details`, { params })
  },
  getChatGPTAnalyticsConversation: (request) => {
    const { pageId, params } = request
    return instance().get(`/api/openai/${pageId}/cms/analytics-conversation`, { params })
  },
  getChatGPTQuota: (request) => {
    const { pageId } = request
    return instance().get(`/api/openai/${pageId}/cms/gpt-rag-config/quota`)
  },
  getChatGPTUsage: (request) => {
    const { pageId, params } = request
    return instance().get(`/api/openai/${pageId}/cms/analytic/number-of-used-gpt`, { params })
  }
}

export default gptApi



// WEBPACK FOOTER //
// ./src/api/gpt.js